module.exports = __webpack_public_path__ + "static/media/sherry.38dd4d22.png";